import styles from './Badge.module.scss'

import Cross from '../../../../assets/icons/cross.svg'
import Check from '../../../../assets/icons/check.svg'
import { IInputStatus } from '../../../../interface/progress.interface'

interface Props {
  status: IInputStatus
  badge?: string | null
  isSuccessBadge?: boolean
  isPercentBadge?: boolean
}

const Badge = ({ status, badge, isSuccessBadge = true, isPercentBadge = true }: Props) => {
  return (
    <div
      className={`${styles.wrapper} ${
        (status === IInputStatus.none || status === IInputStatus.change) && badge ? styles.idleWrapper : ''
      }`}
    >
      {((status === IInputStatus.error || status === IInputStatus.apiError) && (
        <div className={styles.errorBadge}>
          {/* <Cross /> */}
          <img src={Cross} alt='x' />
        </div>
      )) ||
        (isSuccessBadge && status === IInputStatus.success && (
          <div className={styles.successBadge}>
            {/* <Check /> */}
            <img src={Check} alt='ok' />
          </div>
        )) ||
        ((isPercentBadge && status === IInputStatus.none || status === IInputStatus.change) && badge && (
          <div className={styles.idleBadge}>{badge}</div>
        ))}
    </div>
  )
}

export default Badge
